import { Component, inject, OnInit, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ToastComponent } from './shared/components/toast/toast.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class App implements OnInit {
  renderer = inject(Renderer2);
  router = inject(Router);
  private isBrowser: boolean;

  darkHeaderRoutes = [
    '/privacy-policy',
    '/terms-conditions',
    '/refund_policy',
    '/request-account',
    '/faq',
    '/blog',
    '/blog-detail',
  ];

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    // Detect hash in URL and redirect to 404
    if (this.isBrowser && window.location.hash && window.location.hash.length > 1) {
      window.location.href = window.location.origin + '/not-found';
      return;
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentRoute = event.urlAfterRedirects;

        // Scroll to top on navigation
        if (this.isBrowser) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // Check if current route matches any route in array (supports dynamic routes)
        const isDarkRoute = this.darkHeaderRoutes.some(route =>
          currentRoute === route || currentRoute.startsWith(route + '/')
        );

        if (this.isBrowser) {
          const header = document.querySelector('#header');
          if (header) {
            if (isDarkRoute) {
              this.renderer.addClass(header, 'dark');
            } else {
              this.renderer.removeClass(header, 'dark');
            }
          }
        }
      });
  }
}
